import React from "react";
import { Source, Layer } from "react-map-gl";
import { useRecoilValue } from "recoil";

import { layerDefFormatSelector } from "./recoil";

export default function LayersComponent({ layersIDs }) {
  if (!layersIDs?.length) {
    return null;
  }

  return (
    <>
      {layersIDs.map((layerID, index) => (
        <LayerComponent key={layerID} layerID={layerID} />
      ))}
    </>
  );
}

const LayerComponent = ({ layerID }) => {
  const layerDef = useRecoilValue(layerDefFormatSelector(layerID))

  return (
    <>
      {layerDef && (
        <Source key={layerID} {...layerDef.source}>
          <Layer key={layerDef.layer.id} {...layerDef.layer}></Layer>
          {OverLayersComponent(layerDef.overLayers)}
        </Source>
      )}
    </>
  );
};

const OverLayersComponent = (overLayers) => {
  if (!overLayers || overLayers.length === 0) {
    return null
  }

  return overLayers.map((ol) => {
    return (<Layer key={ol.id} {...ol}></Layer>)
  })
}